import { render, staticRenderFns } from "./YgUserAdd.vue?vue&type=template&id=04d7b7db&scoped=true"
import script from "./YgUserAdd.vue?vue&type=script&lang=js"
export * from "./YgUserAdd.vue?vue&type=script&lang=js"
import style0 from "./YgUserAdd.vue?vue&type=style&index=0&id=04d7b7db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d7b7db",
  null
  
)

export default component.exports